import axios from 'axios'

import qs from 'querystring'
import router from "@/router"; // 必须导入独立的路由实例

const request = axios.create({
  baseURL: '',
  timeout: 5000,
  headers: {
    "time": new Date().getTime(),
  },
  transformRequest: [function (data, headers) {
    if (headers['Content-Type'] == 'application/json') {
      return JSON.stringify(data)
    }
    data = qs.stringify(data)
    return data
  }]
})

request.interceptors.response.use(response => {
  if (response.data?.errorCode !== undefined) {
    const errorCode = response.data.errorCode
    if (errorCode == 401) {

      console.log(errorCode);
      router.push({
        path: "/login"
      });

      //window.location.href = window.location.protocol + "//" + window.location.host + window.location.port + "/login";
      return;
    }
  }
  return response;
})

export default request
